import React, { useEffect, useState } from 'react';
import {twMerge} from "tailwind-merge"; 
import logo from '../../assets/logo/bg.jpg';
import SurveyService from '../../service/surveyService';
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useField from '../../components/FieldProps';
interface OptionProps {
  id: string|number;
  name: string;
  labelEn: string;
  labelFr: string;
}
export  interface InterfaceData {
  question1: string|null; 
  question2: string|null; 
  question3: string|null; 
  question4: string|null; 
  question5: string|null; 
  question6: string|null; 
  question7: string|null; 
  question8: string|null; 
  question9: string|null; 
  question10: string|null; 
}
interface OptionAssistance {
  id: number;
  label: string;
  fr: string;
  en: string;
  checked: boolean;
}
interface OptionService {
  id: number;
  fr: string;
  en: string;
  label: string;
  checked: boolean;
}
const Home = () => {
 // const phonePattern = /^[1-9]{8}$/;
  const QuestionLabels = [
    {
      fr: "Quel est le nom de votre entreprise ?",
      en: "What is your company name ?"
    },
    {
      fr: "Quel est votre numéro de téléphone ?",
      en: "What is your phone number ?"
    },
    {
      fr: "Sur une échelle de 1 à 10 (1 étant la note la moins élevée et 10 la note la plus élevée), Comment évaluez-vous la facilité d'accès au service client (téléphone, email, WhatsApp) ?",
      en:"  On a scale of 1 to 10 (1 being the lowest and 10 the highest), how would you rate the ease of access to customer service (phone, email, WhatsApp)?",
    },
    {
      fr: "Sur une échelle de 1 à 10 (1 étant la note la moins élevée et 10 la note la plus élevée), Comment évaluez-vous la rapidité de réponse du service client ?",
      en: "On a scale of 1 to 10 (1 being the lowest and 10 the highest), how would you rate the speed of customer service response ?",
    },
    {
      fr: "Sur une échelle de 1 à 10 (1 étant la note la moins élevée et 10 la note la plus élevée), comment évaluez-vous l'assistance du service client ?",
      en: "On a scale of 1 to 10 (1 being the lowest and 10 the highest), how would you rate customer service support ?"
    },
    {
      fr: "Le personnel du service client était-il courtois et professionnel ?",
      en: "Were customer service staff courteous and professional ?"
    },
    {
      fr: "Le temps d’attente avant d’obtenir une réponse était-il satisfaisant ?",
      en: "Was the waiting time for a response satisfactory?"
    },
    {
      fr: "Que souhaiteriez-vous que nous améliorions pour mieux vous servir ?",
      en: "What would you like us to improve to serve you better ?"
    },
    {
      fr: "Sur une échelle de 1 à 10 (1 étant le plus bas et 10 le plus élevé), quelle serait la probabilité que vous recommandiez notre entreprise à une personne que vous connaissez ?",
      en: " On a scale of 1 to 10 (1 being the lowest and 10 the highest), how likely would you be to recommend our company to someone you know ?"
    },


    {
      fr: "Selon vous, quelles améliorations devraient être apportées au service client ? ",
      en: "What improvements do you think should be made to customer service?"
    }
  ];
  
  // const [formData, setFormData] = useState<InterfaceData>({
  //   question1: "",
  //   question2: "",
  //   question3: "",
  //   question4: "",
  //   question5: "",
  //   question6: "",
  //   question7: "",
  //   question8: "",
  //   question9: "",
  //   question10: "",
  // });
  const [errors, setErrors] = useState({
    question1: '',
    question2: '',
    question3: "",
    question4: "",
    question5: "",
    question6: "",
    question7: "",
    question8: "",
    question9: "",
    question10: "",
  });
  
  const [loading, setLoading] = useState(false);
  const listAssistance:OptionProps[] =   [{id: 1,labelFr:"Oui",labelEn:"Yes",name:"oui"},{id: 2, labelFr:"Non",labelEn:"No",name:"non"},{id: 3,labelFr:"A admeliorer",labelEn:"To be improved",name:"a admeliorer"}]
  const listTemps:OptionProps[] =  [{id: 1,labelFr:"Oui",labelEn:"Yes",name:"oui"},{id: 2, labelFr:"Non",labelEn:"No",name:"non"},{id: 3,labelFr:"A admeliorer",labelEn:"To be improved",name:"a admeliorer"}]
 

  //  const validate = () => {
  //   const newErrors = {...errors};
  //   // Vérifier si les champs sont vides
  //   let v = true;
  //   const listError = [...Object.entries(errors)]
  //   console.log("liste error ",listError);


  //   if ( !input_1.value ) {
  //     newErrors.question1 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!input_2.value) {
  //     newErrors.question2 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!scale_3.value ) {
  //     newErrors.question3 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!scale_4.value) {
  //     newErrors.question4 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!scale_5.value) {
  //     newErrors.question5 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!radio_6.value) {
  //     newErrors.question6 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!radio_7.value) {
  //     newErrors.question7 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!input_8.value) {
  //     newErrors.question8 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!scale_9.value) {
  //     newErrors.question9 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
  //   if (!input_10.value) {
  //     newErrors.question10 = 'Ce champ ne peut pas être vide ou incorrecte..';
  //     v = false;
  //   }
   

  //   setErrors(newErrors);
  //   return v; // Retourne true si pas d'erreur
  // };

  const validation = ()=>{
   let isValid =( input_1.validate() && input_2.validate() && scale_3.validate() && scale_4.validate() && scale_5.validate() && radio_6.validate() && radio_7.validate() && input_8.validate() && scale_9.validate() && input_10.validate());
   
   return isValid;
  }
  const clear = () => {
    input_1.onClear();
    input_2.onClear();
    scale_3.onClear();
    scale_4.onClear();
    scale_5.onClear();
    radio_6.onClear();
    radio_7.onClear();
    input_8.onClear();
    scale_9.onClear();
    input_10.onClear();
  
    // Réinitialiser les erreurs
    setErrors({
      question1: '',
      question2: '',
      question3: '',
      question4: '',
      question5: '',
      question6: '',
      question7: '',
      question8: '',
      question9: '',
      question10: '',
    });
  
    toast.info("Le formulaire a été réinitialisé.", { toastId: "id-clear" });
  };

  const handleSubmit = async (e: React.FormEvent) =>  {
  // console.log("formdata before",formData);
    e.preventDefault();
    // Validation des champs
    //if (!validate()) {
      if (!validation()) {
      toast.error("Veuillez remplir tous les champs",{toastId:"id error 2"});
      return;
    }else{
      //console.log("handle submit", formData)
      const request:InterfaceData = {
        question1:input_1.value?.toString()??" " ,
        question2:input_2?.value?.toString()??" " ,
        question3:scale_3?.value?.toString()??" " ,
        question4:scale_4?.value?.toString()??" " ,
        question5:scale_5?.value?.toString()??" " ,
        question6:radio_6?.value?.toString()??" " ,
        question7:radio_7?.value?.toString()??" " ,
        question8:input_8?.value?.toString()??" " ,
        question9:scale_9?.value?.toString()??" " ,
        question10:input_10?.value?.toString()??" " ,
      };
      console.log(request);
      setLoading(true);
      console.log('data to send' ,request)
    try {
      const response = await SurveyService.sendSurvey(request) ;
            if (response.status === 'OK' && response.message === 'SUCCESS') {
                const av = response.data;
                toast.success("Vos données ont été envoyées avec succès",{toastId:"id success "});
            } else {
                // seterroPage(true);
                toast.error("Erreur lors de l'envoie de vos données",{toastId:"id error else"});

                throw new Error('error lors de la recuperation  de la list des vaccins');
            }
    } catch (error) {
      toast.error("Erreur lors de l'envoie de vos données",{toastId:"id error "});
    }finally{
      setLoading(false);
    }
    }

  };
  

  // const listIput = [
  //   {nom:'input',value: useField({ type: "inputText", name: "question1", id: "1", labelFr: QuestionLabels[0].fr, labelEn: QuestionLabels[0].en })},
  //   {nom:'input',value: useField({ type: "inputText", name: "question1", id: "1", labelFr: QuestionLabels[0].fr, labelEn: QuestionLabels[0].en })}

  // ]
  //input text
  const input_1 = useField({ type: "inputText", name: "question1", id: "1", labelFr: QuestionLabels[0].fr, labelEn: QuestionLabels[0].en });
  const input_2 = useField({ type: "phone",isRequired:true,placeHolder:"ex 6XX XXX XXX",  name: "question2", id: "2", labelFr: QuestionLabels[1].fr, labelEn: QuestionLabels[1].en });
  const input_8 = useField({ type: "inputText",  name: "question8", id: "8", labelFr: QuestionLabels[7].fr, labelEn: QuestionLabels[7].en });
  const input_10 = useField({ type: "inputText", name: "question10", id: "10", labelFr: QuestionLabels[9].fr, labelEn: QuestionLabels[9].en });
  //checkbox
  //radio
  const radio_6 = useField({ type: "radio", name: "question6", id: "6", labelFr: QuestionLabels[5].fr, labelEn: QuestionLabels[5].en,options: listAssistance });
  const radio_7 = useField({ type: "radio", name: "question7", id: "7", labelFr: QuestionLabels[6].fr, labelEn: QuestionLabels[6].en,options: listTemps });
  //scale
  const scale_3 = useField({ type: "scale", name: "scale3", id: "3", labelFr: QuestionLabels[2].fr, labelEn:QuestionLabels[3].en });
  const scale_4 = useField({ type: "scale", name: "scale4", id: "4", labelFr: QuestionLabels[3].fr, labelEn: QuestionLabels[4].en });
  const scale_5 = useField({ type: "scale", name: "scale5", id: "5", labelFr: QuestionLabels[4].fr, labelEn: QuestionLabels[5].en });
  const scale_9 = useField({ type: "scale", name: "scale9", id: "9", labelFr: QuestionLabels[8].fr, labelEn: QuestionLabels[9].en });




// useEffect(() => {
// input_1.setValue(formData.question1);
// input_2.setValue(formData.question2);
// scale_3.setValue(formData.question3);
// scale_4.setValue(formData.question4);
// scale_5.setValue(formData.question5);
// radio_6.setValue(formData.question6);
// radio_7.setValue(formData.question7);
// input_8.setValue(formData.question8);
// scale_9.setValue(formData.question9);
// input_10.setValue(formData.question10);
// }, [input_1.value,input_2.value,scale_3.value,scale_4.value,scale_5.value,radio_6.value,radio_7.value,input_8.value,scale_9.value,input_10.value]);


  return (
   <div className='flex flex-col gap-y-5 justify-center items-center flex-grow '>
    <div  
    style={{
      backgroundImage: `linear-gradient(to right, white, transparent), url(${logo})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#FAFAFA'
    }}  
   className="flex py-9 px-9 w-full rounded-[35px]">
      <div  className="flex flex-col w-1/2 px-[10px] font-[500]">
      <p className='text-[#25AAE1] text-[64px] font-bold text-wrap'>ENQUETE DE SATISFACTION DE NEXAH</p>
      <br />
      <p>Le sondage prendra environ 5 minutes.</p>
      <br />
      <p>Dans le but de vous offrir la meilleure <br /> expérience client qui soit, nous vous prions <br /> de nous aider à mieux vous satisfaire en <br /> répondant à ces quelques questions.</p>
      <div className="flex py-5">
      <div  className="flex rounded-[10px] text-[28px] font-[600]  flex-grow-0 text-white bg-[#25AAE1] cursor-pointer   py-3 px-5 justify-center items-center">
      Démarrer Maintenant
      </div>
      </div>
      
      </div>
      <div className="flex flex-col  w-1/2"></div>
    </div>
    <form className="flex flex-col gap-y-4 rounded-[35px] py-9 px-9 w-full min-h-64 bg-[#FAFAFA] ">
      <div className="flex font-[400] text-[24px] py-7">Les questions marquées par un astérix sont obligatoires (<span className='text-red-500'>*</span>)</div>
  
   {/* {input_1.field}
   {(input_1.value?.length === 0 ) && <span className='text-red-600 '> {errors.question1}</span>} */}
   {input_1.field}
   {input_2.field}
   {/* {(input_2.value?.length === 0 ) && <span className='text-red-600 '> {errors.question2}</span>} */}

   {scale_3.field}
   {/* {(scale_3.value?.length === 0 ) && <span className='text-red-600 '> {errors.question3}</span>} */}

   {scale_4.field}
   {/* {(scale_4.value?.length === 0 ) && <span className='text-red-600 '> {errors.question4}</span>} */}

   {scale_5.field}
   {/* {(scale_5.value?.length === 0 ) && <span className='text-red-600 '> {errors.question5}</span>} */}

   {radio_6.field}
   {/* {(radio_6.value?.length === 0 ) && <span className='text-red-600 '> {errors.question6}</span>} */}

   {radio_7.field}
   {/* {(radio_7.value?.length === 0) &&<span className='text-red-600 '>{errors.question7} </span>} */}

   {input_8.field}
   {/* {(input_8.value?.length === 0) &&<span className='text-red-600 '>{errors.question8} </span>} */}

   {scale_9.field}
   {/* {(scale_9.value?.length === 0)&&<span className='text-red-600 '>{errors.question9} </span>} */}

   {input_10.field}
   {/* {(input_10.value?.length === 0 ) &&<span className='text-red-600 '>{errors.question10} </span>} */}
      <div className="flex py-4 w-[400] text-[24px]">Vous pouvez imprimer une copie de votre réponse après envoi</div>
      <div className="flex gap-x-8">
        <button  disabled={loading}  onClick={handleSubmit}  className="flex gap-x-3 rounded-xl text-[28px] font-[600] flex-grow-0 text-white bg-[#25AAE1] cursor-pointer   py-3 px-6 justify-center items-center">Envoyer  {loading && <ClipLoader color="white" loading size={30} />} </button>
        <div onClick={clear} className="flex rounded-xl text-[28px] font-[600] flex-grow-0 text-[#25AAE1]   border-[2px] border-[#25AAE1] cursor-pointer   py-3 px-6 justify-center items-center">Effacer le formulaire</div>
      </div>
     </form>
     {/* <button className='py-3 px-5 bg-slate-600 text-white flex justify-center items-center rounded-md' onClick={()=>{console.log({question1:input_1.value,question2:input_2.value,question3:scale_3.value,question4:scale_4.value,question5:scale_5.value,question6:radio_6.value,question7:radio_7.value,question8:input_8.value,question9:scale_9.value,question10:input_10.value});validation()}}>  text  </button> */}
     <ToastContainer />
   </div>
  );
};

export default Home;